<template lang="pug">
section#start-location
  section.banner-area.relative
    .overlay.overlay-bg
    .container
      .row.fullscreen.align-items-center.justify-content-between
        .col-lg-6.col-md-7
          .banner-content(v-show="parsing")
            full-loader
          .banner-content(v-show="!parsing")
            h1(v-html="$t('startLocation.title')")
            p(v-html="$t('startLocation.subtitle')")
            .box
              input.inputfile#locFile(accept=".json", type="file", name="locFile", v-on:change="fileAdd")
              label(v-bind:title="uploaderLabel", v-bind:class="{'primary-btn': !locFile && !loading, 'genric-btn link': locFile || loading}", for="locFile")
                | {{ uploaderLabel | crop(15, '...') }}
                loader(v-show="loading")
                span(v-show="!locFile && !loading").lnr.lnr-cloud-upload
              button.primary-btn.next-btn(v-on:click.prevent="filePreTreat", v-show="locFile")
                | {{ $t('controls.next') }}
                span.lnr.lnr-arrow-right
            span.drive-select(v-show="pickerApiLoaded")
              | {{ $t('controls.or') }}
              | &nbsp;
              a#drive-btn(href="/", v-on:click.prevent="") {{ $t('controls.loadDrive') }}
        .rpanel.col-lg-6.col-md-5
          .overlay.overlay-bg
            .counter
              p.step {{ $t('controls.step') }}
              p
                span.current 3
                span /4
      .row
        .col
          router-link.genric-btn.circle.link(to="/start/meals")
            span.lnr.lnr-arrow-left
            | &nbsp;
            | {{ $t('controls.back') }}

        .col.text-right
          router-link.skip-btn.genric-btn.circle.link(to="/start/calendar")
            | {{ $t('controls.skip') }}
            | &nbsp;
            span.lnr.lnr-arrow-right

  section.next-area.relative
    .overlay.overlay-bg
    .container
      .row
        .col-md-10.offset-md-1
          p.next-title {{ $t('controls.next') }}: {{ $t('startLocation.next') }}
</template>

<script>
import Project from '@/constants';
import axios from 'axios';
import saveState from 'vue-save-state';
import Loader from '@/components/partials/Loader';
import FullLoaer from '@/components/partials/FullLoader';

export default {
  name: 'StartMeals',
  components: {
    loader: Loader,
    'full-loader': FullLoaer,
  },
  mixins: [saveState],
  data() {
    return {
      locFile: null,
      pickerApiLoaded: false,
      oauthToken: null,
      fromDrive: false,
      loading: false,
      parsing: false,
    };
  },
  computed: {
    uploaderLabel() {
      if (this.loading) return '';
      const prefix = this.fromDrive ? '(drive) ' : '';
      return this.locFile ? `${prefix}${this.locFile.name}` : this.$t('controls.upload');
    },
  },
  metaInfo() {
    return {
      title: this.$t('startLocation.meta.title'),
    };
  },
  methods: {
    getSaveStateConfig() {
      return {
        cacheKey: 'start.location',
        saveProperties: ['fromDrive'],
      };
    },
    onApiLoad() {
      if (window.gapi) {
        if (!window.gapi.auth2) window.gapi.load('auth2', this.onAuthApiLoad);
        else this.onAuthApiLoad();
        if (!window.gapi.picker) window.gapi.load('picker', this.onPickerApiLoad);
        else this.pickerApiLoaded = true;
      } else {
        setTimeout(() => {
          this.onApiLoad();
        }, 300);
      }
    },
    onAuthApiLoad() {
      const authBtn = document.getElementById('drive-btn');
      authBtn.disabled = false;
      authBtn.addEventListener('click', () => {
        if (this.oauthToken) this.createPicker();
        else {
          window.gapi.auth2.authorize({
            client_id: Project.google.picker.clientId,
            scope: Project.google.picker.scope,
          }, this.handleAuthResult);
        }
      });
    },
    onPickerApiLoad() {
      this.pickerApiLoaded = true;
      this.createPicker();
    },
    handleAuthResult(authResult) {
      if (authResult && !authResult.error) {
        this.oauthToken = authResult.access_token;
        this.createPicker();
      }
    },
    createPicker() {
      if (this.pickerApiLoaded && this.oauthToken) {
        const picker = new window.google.picker.PickerBuilder()
          .addView(window.google.picker.ViewId.DOCS)
          .setOAuthToken(this.oauthToken)
          .setDeveloperKey(Project.google.picker.developerKey)
          .setCallback(this.pickerCallback)
          .build();
        picker.setVisible(true);
      }
    },
    pickerCallback(data) {
      if (data[window.google.picker.Response.ACTION] === window.google.picker.Action.PICKED) {
        this.loading = true;
        this.locFile = null;
        const doc = data[window.google.picker.Response.DOCUMENTS][0];
        const id = doc[window.google.picker.Document.ID];
        const name = doc[window.google.picker.Document.NAME];
        const url = `https://www.googleapis.com/drive/v3/files/${id}?key=${Project.google.picker.developerKey}&access_token=${this.oauthToken}&alt=media`;
        axios.get(url)
          .then((res) => {
            $('#locFile').val('');
            this.locFile = {
              name,
              data: res.data,
            };
            this.fromDrive = true;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    fileAdd() {
      const selectedFile = document.getElementById('locFile').files[0];
      if (!selectedFile) return;
      this.loading = true;
      this.locFile = selectedFile;
      this.fromDrive = false;
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = event.target.result;
        const name = this.locFile.name;
        const size = this.locFile.size;
        this.locFile = {
          name,
          size,
          data,
        };
      };
      reader.onloadend = () => {
        this.loading = false;
      };
      reader.readAsText(selectedFile);
    },
    filePreTreat() {
      this.parsing = true;
      setTimeout(this.fileTreat, 300);
    },
    fileTreat() {
      const locations = [];
      const SCALAR_E7 = 0.0000001;
      const jsonData = JSON.parse(this.locFile.data);

      let lastCoords = { lat: 0, lng: 0 };
      jsonData.locations.reverse().forEach((location) => {
        const locTS = parseInt(location.timestampMs, 10);
        const locDate = new Date(locTS);
        if (locDate >= this.$store.firstDate && locDate <= this.$store.lastDate) {
          const nLat = Math.round(location.latitudeE7 * SCALAR_E7 * 100) / 100;
          const nLng = Math.round(location.longitudeE7 * SCALAR_E7 * 100) / 100;
          const newCoords = { lat: nLat, lng: nLng };
          if (this.gpsDistance(lastCoords, newCoords) >= 10) {
            locations.push({
              date: locDate,
              lat: nLat,
              lng: nLng,
            });
            lastCoords = newCoords;
          }
        }
      });
      this.$store.sugarData.getCollection('locations').clear();
      this.$store.sugarData.getCollection('locations').insert(locations);
      window.oauthToken = this.oauthToken;
      this.$router.push('/start/calendar');
    },
    gpsDistance(latlng1, latlng2) {
      let lat1 = latlng1.lat;
      let lat2 = latlng2.lat;
      const lon1 = latlng1.lng;
      const lon2 = latlng2.lng;

      function toRad(value) {
        return value * (Math.PI / 180);
      }

      const R = 6371;
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      lat1 = toRad(lat1);
      lat2 = toRad(lat2);

      // eslint-disable-next-line
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = R * c;
      return d;
    },
  },
  mounted() {
    this.oauthToken = window.oauthToken;
    this.onApiLoad();
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'

#start-location
  overflow hidden
  background white
  .banner-content
    padding-right base-padding

    .loader
      position relative
      top 4px

  .next-btn
    margin-left 15px

  .drive-select
    margin-left 15px
    a
      font-variant small-caps
      text-transform uppercase
      font-size .9em
      transition color ease .2s
      &:hover
        color color-main

.next-area
  background color-main
  padding base-padding * 2
  background url(/static/img/hypnotize.png) repeat
  .overlay-bg
    padding base-padding
    background rgba(color-main, .8)
  p
    color white
    font-size 2.5em
    font-weight 200
    text-align center
    font-variant small-caps
    text-transform lowercase
    letter-spacing 0.2em
    line-height 1em

.banner-area
  padding-bottom base-padding
  //border-bottom 1px solid rgba(color-base, .25)

.rpanel
  background url(/static/img/map.jpg) no-repeat center/cover
  //width 50%
  height 100%
  top 0px
  right 0
  position absolute

  .overlay-bg
    background rgba(226, 109, 92, 0.8)
    display flex
    align-items center
    text-align center

  .counter
    margin auto
    color white
    font-size 15em
    span:not(.current)
      font-weight 200
      opacity .75
    .step
      font-size 0.2em
      font-weight 200
      font-variant small-caps
      text-transform lowercase
      letter-spacing 0.3em
      position relative
      top -120px
    .current
      font-weight 900

@media (max-width: size-sm)
  .rpanel
    display none
    visibility hidden
</style>



// WEBPACK FOOTER //
// src/components/pages/Start.Location.vue